import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import clsx from "clsx";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IconSvg } from "../../../common/utils/assets";
import { getLocalstorage } from '../../../common/utils/other';
import { API_CODE, KEY_SETTING, TARGET } from "../../../common/utils/const";
import { authServ, settingServ, userServ } from "../../../services";
import { authAct, layoutActions } from "../../../store/actions";

export default function HeadPage({ classes, open, setOpen }) {
  const dispatch = useDispatch();
  const changeAppTitle = (appTitle) =>
    dispatch(layoutActions.changeAppTitle(appTitle));
  const { appTitle } = useSelector((state) => state.layout);

  const auth = useSelector((state) => state.auth);
  const dispath = useDispatch();

  const displayName = useMemo(() => {
    let ret = auth?.user?.profile?.username ?? '';

    return ret;
  }, [auth]);

  /**
   * actions
   */
  const handleLogout_click = async () => {
    const { data } = await authServ.signout();
    localStorage.removeItem("USER");
    const sourceLocal = getLocalstorage(TARGET);
    window.location.href = data?.url_logout + (sourceLocal ? `?${TARGET}=${sourceLocal}` : '');
  };

  /**
   * renders
   */
  function renderDashboardHead() {
    let ret;
    ret = (
      <>
        <div className="header-top">
          <div style={{ display: 'flex', alignItems: 'center', gap: 5}}>
            <img alt="" src="kajima_logo_1.png" height="20"></img>
          </div>
          <div className="user-info">
            {displayName && (
              <IconButton size="small" onClick={handleLogout_click}>
                <ExitToAppIcon
                  fontSize="small"
                  color="secondary"
                  style={{ width: 24, height: 24, color: "#234738" }}
                />
              </IconButton>
            )}
          </div>
        </div>
      </>
    );

    return ret;
  }
  return (
    <AppBar
      position="fixed"
      color="transparent"
      className={
        clsx(classes.appBar, {
          [classes.appBarShift]: open,
        }) + " immerse-header"
      }
    >
      <Toolbar style={{ display: "block" }}>{renderDashboardHead()}</Toolbar>
      <div className="display-name">
        {displayName ? (
          <>
            <h3>{displayName}</h3>
            {/* <h4>PREFERENCES</h4> */}
          </>
        ) : (
          <h3>Sign In</h3>
        )}
      </div>
    </AppBar>
  );
}
